import cookies, { CookieAttributes } from 'js-cookie';

export class CookieService {
    read(name: string): string | undefined {
        return cookies.get(name);
    }

    write(
        name: string,
        value: string | Record<string, any>,
        options?: CookieAttributes & { permanent?: boolean },
    ) {
        if (options && options.permanent) {
            // Maximum date
            options.expires = new Date(2147483647000);
        }
        cookies.set(name, value, options);
    }
}

export const cookie = new CookieService();
